module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_ny_cn@2x.50f7f410.png";